import {ref} from "vue";
import {defineStore} from "pinia";

export const useStatus = defineStore('status', () => {
    const loading = ref(true)
    const available = ref(false)
    const message = ref<{ color: string, message: string } | false>(false)
    const termsUpdateTimestamp = ref(Number.MAX_VALUE)
    const termsUpdateReason = ref("")

    const updateStatus = () => {
        const location = window.location
        fetch(location.protocol + '//' + location.host + '/status.json').then(response => {
            return response.json()
        }).then(data => {
            available.value = data.available
            if(data.message) {
                message.value = {color: data.messageColor, message: data.message}
            } else {
                message.value = false
            }
            termsUpdateTimestamp.value = data.termsUpdate
            termsUpdateReason.value = data.termsUpdateReason
            loading.value = false
        }).catch((e) => {
            console.error("Could not connect to server", e)
            loading.value = false
            available.value = false
            message.value = {color: 'warning', message: 'Could not connect to server'}
        })
    }

    setInterval(updateStatus, 60000)
    updateStatus()


    return {
        loading,
        available,
        message,
        termsUpdateTimestamp,
        termsUpdateReason,
    }
});
